import { ReviewJob, ReviewJobWithPatient } from "../models/review-job.model";
import { createAction, props } from "@ngrx/store";

export enum ActionTypes {
  GetAll = "[ReviewJobs/API] Get All",
  GetAllSuccess = "[ReviewJobs/API] Get All Success",
  GetAllFailure = "[ReviewJobs/API] Get All Failure",

  OpenReviewJob = "[ReviewJobs] Open Review Job",

  CompleteReviewJob = "[ReviewJobs/API] Complete Review Job",
  CompleteReviewJobSuccess = "[ReviewJobs/API] Complete Review Job Success",
  CompleteReviewJobFailure = "[ReviewJobs/API] Complete Review Job Failure",

  UpdateReviewJobProvider = "[ReviewJobs/API] Update Review Job Provider",
  UpdateReviewJobProviderSuccess = "[ReviewJobs/API] Update Review Job Provider Success",
  UpdateReviewJobProviderFailure = "[ReviewJobs/API] Update Review Job Provider Failure",

  OpenPatientReport = "[ReviewJobs] Open Patient Report",

  DeleteReviewJob = "[ReviewJobs] Delete Review Job",
  DeleteReviewJobSuccess = "[ReviewJobs] Delete Review Job Success",
  DeleteReviewJobFailure = "[ReviewJobs] Delete Review Job Failure",
}

export const getAllReviewJobs = createAction(ActionTypes.GetAll);

export const getAllReviewJobsSuccess = createAction(
  ActionTypes.GetAllSuccess,
  props<{ reviewJobs: ReviewJobWithPatient[] }>()
);

export const getAllReviewJobsFailure = createAction(
  ActionTypes.GetAllFailure,
  props<{ error: any }>()
);

export const openReviewJob = createAction(
  ActionTypes.OpenReviewJob,
  props<{ reviewJob: ReviewJob }>()
);

export const completeReviewJob = createAction(
  ActionTypes.CompleteReviewJob,
  props<{ patientId: string; sessionId: string }>()
);

export const completeReviewJobSuccess = createAction(
  ActionTypes.CompleteReviewJobSuccess,
  props<{ reviewJobId: string }>()
);

export const completeReviewJobFailure = createAction(
  ActionTypes.CompleteReviewJobFailure,
  props<{ error: any }>()
);

export const updateReviewJobProvider = createAction(
  ActionTypes.UpdateReviewJobProvider,
  props<{ patientId: string; reviewJobId: string }>()
);

export const updateReviewJobProviderSuccess = createAction(
  ActionTypes.UpdateReviewJobProviderSuccess,
  props<{ reviewJobId: string }>()
);

export const updateReviewJobProviderFailure = createAction(
  ActionTypes.UpdateReviewJobProviderFailure,
  props<{ error: any }>()
);

export const openPatientReport = createAction(
  ActionTypes.OpenPatientReport,
  props<{ patientId: string; sessionId: string }>()
);

export const deleteReviewJob = createAction(
  ActionTypes.DeleteReviewJob,
  props<{ jobId: string }>()
);

export const deleteReviewJobSuccess = createAction(
  ActionTypes.DeleteReviewJobSuccess,
  props<{ jobId: string }>()
);

export const deleteReviewJobFailure = createAction(
  ActionTypes.DeleteReviewJobFailure,
  props<{ error: any }>()
);

export const reviewJobErrorActions = [
  getAllReviewJobsFailure,
  completeReviewJobFailure,
  updateReviewJobProviderFailure,
];
